import { render, staticRenderFns } from "./rewarddetails.vue?vue&type=template&id=c8610b8c"
import script from "./rewarddetails.vue?vue&type=script&lang=js"
export * from "./rewarddetails.vue?vue&type=script&lang=js"
import style0 from "./rewarddetails.vue?vue&type=style&index=0&id=c8610b8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports